export default function (value) {
  return `${value.toFixed(2)}km`
}